export default "__VITE_ASSET__tXCx5VoJ__"